export enum EventNames {
  ON_MAP_DRAG_END = 'onMapDragEnd',
  ON_MAP_DRAG = 'onMapDrag',
  ON_MAP_READY = 'onMapReady',
  ON_LOCATION_DETAILS_CHANGE = 'onLocationDetailsChange',
}
